<div class="container">
  <div class="row">
    <!-- <div class="col-xl-10 col-lg-10 col-md-10">
      <h1 mat-dialog-title>Coupon Code: {{data.title}}</h1>
    </div> -->
    <div class="col-xl-12 col-lg-12 col-md-12 text-end">
      <button mat-icon-button [mat-dialog-close]="true">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <div class="dialog-content p-2">
    <div class="single-deals-coupon-box">
      <div class="col-xl-12 col-lg-12 col-md-12 text-center" *ngIf="qrCodeImage">
        <img mat-card-image *ngIf="qrCodeImage && !showBarcode" (click)="onClickCode()" matTooltipPosition="above"
          [matTooltip]="resource.click_to_show_barcode" [src]="qrCodeImage"
          style="height: 140px;width: 140px;cursor: pointer;">
        <div class="my-barcode">
          <ngx-barcode style="cursor: pointer;" *ngIf="code && showBarcode" bc-element-type="svg" [bc-value]="code"
            bc-format="CODE128" bc-height="60" matTooltipPosition="above" [matTooltip]="resource.click_to_show_qr"
            (click)="onClickCode()"></ngx-barcode>
        </div>
        <div class="deals-coupon-content padding-0">
          <h2>{{offerTypeTitle}}</h2>
          <div class="price" *ngIf="campaignDetail?.regularPrice > 0 && campaignDetail?.isDisplayProductPrice">
            <span class="new-price"
              *ngIf="campaignDetail?.offerType == 'BUYGET'"><span>{{campaignDetail?.currencySymbol}}</span><span>{{campaignDetail?.regularPrice | amountFormat}}</span></span>
            <span class="new-price"
              *ngIf="campaignDetail?.offerType != 'BUYGET'"><span>{{campaignDetail?.currencySymbol}}</span><span>{{campaignDetail?.offerPrice | amountFormat}}</span></span>
            <span class="old-price"
              *ngIf="campaignDetail?.offerType != 'BUYGET'">{{campaignDetail?.currencySymbol}}{{campaignDetail?.regularPrice | amountFormat}}</span>
          </div>
          <h3>{{campaignDetail?.campaignName}}</h3>
          <p>{{campaignDetail?.offerDescription}}</p>
          <p>{{resource.offer_available_in}} {{location}}</p>
          <div class="show-coupon-code">
            <span>{{resource.copy_code}}:</span>
            <button (click)="onClickCopyCode()" *ngIf="qrCodeImage" class="code-btn" ngxClipboard [cbContent]="[code]"
              [container]="code" [matTooltip]="resource.click_to_copy">{{code}} </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>